import { styleVariants, style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

export const root = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: vars.typography.fontSize.xs,
  fontWeight: vars.typography.fontWeight.medium,
  whiteSpace: 'nowrap',
  transition: `color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}, opacity ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
});

export const status = styleVariants({
  pending: { color: vars.bright.status.info },
  success: { color: vars.bright.status.success },
  error: { color: vars.bright.status.error },
  idle: { color: vars.typography.textColor.tertiary },
});

export const icon = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '12px',
  height: '12px',
});
